import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';
import {LangComponent} from './modals/lang/lang.component';
import {CurrencyComponent} from './modals/currency/currency.component';
import {SiteInfosService, WindowRefService} from '@app/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    langs: Array<{}> = [];
    currency: Array<{}> = [];
    constructor(public dialog: MatDialog, private siteInfosService: SiteInfosService) {
        this.langs = this.siteInfosService.getlistLangs();
        this.currency = this.siteInfosService.getlistCurrency();
    }

    ngOnInit() {
    }
    openDialogLang() {
        const dialogRef = this.dialog.open(LangComponent, {
            data: {lang: this.langs}
        });
        //        dialogRef.afterClosed().subscribe(result => {
        //            console.log(`Dialog result: ${result}`);
        //        });
    }
    openDialogCuurency() {
        const dialogRef = this.dialog.open(CurrencyComponent, {
            data: {currency: this.currency}
        });
        //        dialogRef.afterClosed().subscribe(result => {
        //            console.log(`Dialog result: ${result}`);
        //        });
    }

}
